import React from 'react';
import update from 'immutability-helper';
import { Modal, Button, Row, Col, FormControl, Checkbox, HelpBlock } from 'react-bootstrap';
import moment from 'moment';
import Select from 'react-select';
import Datetime from 'react-datetime';
import find from 'lodash/find';
import pick from 'lodash/pick';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import { get, post } from '../../../../../shared/http/request';
import { handleRecoveryActionValidation } from '../../../../../shared/utils/handleRecoveryActionValidation';
import { handleApiError } from '../../../../../shared/http/error';
import { formatStopLocation } from '../../../../../shared/utils/run';
import Comments from '../../../../../components/Comments/Comments';
import { TRANSPORT_METHODS } from '../../../../../constants';

class SpecialModalGeneric extends React.Component {
    defaultState = {
        commonRuns: [],
        errors: {},
        form: {
            abnormalityId: this.props.abnormalityManifest.abnormalityId,
            abnormalityManifests: [
                {
                    manifestId: this.props.abnormalityManifest.manifest.manifestId,
                    abnormalityManifestId: this.props.abnormalityManifest.abnormalityManifestId,
                },
            ],
            arrivalDate: '',
            carrier: '',
            collectionDate: '',
            comment: '',
            from: '',
            impactedRunIds: [],
            dueDate: moment(this.props.runDate),
            to: '',
            trailerIdentifier: '',
            twoWaySpecial: false,
            unloadingDate: '',
        },
    };

    constructor(props) {
        super(props);

        this.state = {
            ...this.defaultState,
            logisticPartners: [],
            stops: {
                fromStops: [],
                toStops: [],
            },
        };
    }

    componentDidMount() {
        const { abnormalityManifests } = this.state.form;
        get('/api/reports/logistic-partners').then(
            logisticPartners =>
                this.setState({
                    logisticPartners: logisticPartners.logisticPartnerNames.sort(),
                }),
            error =>
                console.log(
                    '[SpecialModalGeneric] Error while getting logistic partners on mount...',
                    error
                )
        );

        if (abnormalityManifests.length > 0) {
            let manifestIds = [];

            if (this.props.collectionManifestId) {
                manifestIds.push(this.props.collectionManifestId);
            } else {
                manifestIds = abnormalityManifests.map(am => am.manifestId);
            }

            post(`/api/abnormality/special/manifests/stops`, {
                manifestIds,
            }).then(
                stops =>
                    this.setState({
                        stops: {
                            fromStops: orderBy(stops.fromStops, ['stopCode'], ['asc']),
                            toStops: orderBy(stops.toStops, ['stopCode'], ['asc']),
                        },
                    }),
                error => {
                    handleApiError(error, this.props.dispatch);
                }
            );
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { stops, form: { abnormalityManifests, from, to } } = this.state;

        if (from && to && (prevState.form.from !== from || prevState.form.to !== to)) {
            const fromStop = find(stops.fromStops, ['stopId', from]);
            const toStop = find(stops.toStops, ['stopId', to]);
            const data = {
                from: fromStop,
                to: toStop,
                manifestIds: abnormalityManifests.map(am => am.manifestId),
            };

            post(`/api/abnormality/manifests/impacted-runs`, data).then(
                response =>
                    this.setState({
                        commonRuns: response.impactedRuns,
                    }),
                error => {
                    handleApiError(error, this.props.dispatch);
                }
            );
        }
    }

    handleChange = e => {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            form: update(this.state.form, {
                [name]: { $set: value },
            }),
        });
    };

    /*handleSelectChange = name => value => {
        this.setState(prevState => ({
            form: update(this.state.form, {
                [name]: { $set: value.split(',') },
            }),
        }));
    };*/

    handleSelectChange = name => value => {

        /*
        console.log(value);
        let selectedValues = value;
        if(undefined != value1 && Array.isArray(value1) && 0 < value1.length){
            value1.map(function(e1){
                selectedValues.push(e1);
                return null;
            })
        }
        console.log(selectedValues);
        */


        this.setState(prevState => ({
            form: update(this.state.form, {
                [name]: { $set: value },
            }),
        }));
    };

    handleDateChange = name => momentDate => {
        this.setState({
            form: update(this.state.form, {
                [name]: { $set: momentDate },
            }),
        });
    };

    handleConfirm = () => {
        const { isEmaSmaManifest } = this.props;
        const { stops, form } = this.state;
        let toValidate = pick(form, [
            'arrivalDate',
            'carrier',
            'collectionDate',
            'dueDate',
            'from',
            'impactedRunIds',
            'to',
            'unloadingDate',
        ]);
        const errors = handleRecoveryActionValidation(toValidate, isEmaSmaManifest);
        this.setState({ errors });

        if (Object.keys(errors).length === 0) {
            const fromStop = find(stops.fromStops, ['stopId', form.from]);
            const toStop = find(stops.toStops, ['stopId', form.to]);
            const data = {
                transportMethod: TRANSPORT_METHODS.SPECIAL,
                from: fromStop,
                to: toStop,
                specialInfo: {
                    arrival: form.arrivalDate,
                    carrier: form.carrier,
                    impactedRuns: form.impactedRunIds.map(iri =>
                        this.state.commonRuns.find(cr => cr.runId === iri.value)
                    ),
                    trailerNumber: form.trailerIdentifier,
                    twoWaySpecial: form.twoWaySpecial,
                },
                dueDate: form.dueDate,
                comment: form.comment,
            };
            if (form.collectionDate && form.collectionDate.isValid()) {
                data.specialInfo.collection = form.collectionDate;
            }
            if (form.unloadingDate && form.unloadingDate.isValid()) {
                data.specialInfo.unloading = form.unloadingDate;
            }
            this.setState(() => ({
                ...this.defaultState,
            }));
            this.props.handleSpecialCreate(data);
        }
    };

    handleClose = () => {
        this.setState(() => ({
            ...this.defaultState,
        }));
        this.props.onClose();
    };

    render() {
        const { showModal } = this.props;
        const { commonRuns, errors, form, logisticPartners, stops } = this.state;
        const formattedCommonRuns = map(commonRuns, run => ({
            value: run.runId,
            label: `${run.routeCode} - ${run.runSequence}`,
        }));

        return (
            <Modal show={showModal} backdrop="static" onHide={this.handleClose} bsSize="lg">
                <Modal.Header>
                    <Modal.Title>Special</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Row>
                            <Col sm={2} style={{ marginTop: 10 }}>
                                From *
                            </Col>
                            <Col sm={4} style={{ marginTop: 5 }}>
                                <FormControl
                                    name="from"
                                    value={form.from}
                                    onChange={this.handleChange}
                                    componentClass="select"
                                >
                                    <option value="">Select from location</option>
                                    {stops.fromStops &&
                                        stops.fromStops.map(stop => (
                                            <option key={stop.stopId} value={stop.stopId}>
                                                {formatStopLocation(stop)}
                                            </option>
                                        ))}
                                </FormControl>
                                {errors.fromLocationName && (
                                    <HelpBlock>
                                        <span className="text-danger">
                                            {errors.fromLocationName}
                                        </span>
                                    </HelpBlock>
                                )}
                            </Col>
                            <Col sm={2} style={{ marginTop: 10 }}>
                                To *
                            </Col>
                            <Col sm={4} style={{ marginTop: 5 }}>
                                <FormControl
                                    name="to"
                                    value={form.to}
                                    onChange={this.handleChange}
                                    componentClass="select"
                                >
                                    <option value="">Select to location</option>
                                    {stops.toStops &&
                                        stops.toStops.map(stop => (
                                            <option key={stop.stopId} value={stop.stopId}>
                                                {formatStopLocation(stop)}
                                            </option>
                                        ))}
                                </FormControl>
                                {errors.toLocationName && (
                                    <HelpBlock>
                                        <span className="text-danger">{errors.toLocationName}</span>
                                    </HelpBlock>
                                )}
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 5, marginBottom: 10 }}>
                            <Col sm={2} style={{ marginTop: 10 }}>
                                Two-way special?
                            </Col>
                            <Col sm={4}>
                                <Checkbox
                                    name="twoWaySpecial"
                                    checked={form.twoWaySpecial}
                                    onChange={this.handleChange}
                                    inline
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={2} style={{ marginTop: 10 }}>
                                Impacted runs {commonRuns && commonRuns.length ? '*' : ''}
                            </Col>
                            <Col sm={4} style={{ marginTop: 5 }}>
                                <Select
                                    name="impactedRunIds"
                                    value={form.impactedRunIds}
                                    options={formattedCommonRuns}
                                    placeholder="Select one or more runs"
                                    isMulti
                                   // simpleValue
                                   // joinValues
                                    delimiter=","
                                    onChange={this.handleSelectChange('impactedRunIds')}
                                />
                                {errors.impactedRunIds && (
                                    <HelpBlock>
                                        <span className="text-danger">{errors.impactedRunIds}</span>
                                    </HelpBlock>
                                )}
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 20 }}>
                            <Col sm={2} style={{ marginTop: 10 }}>
                                Collection date
                            </Col>
                            <Col sm={4} style={{ marginTop: 5 }}>
                                <Datetime
                                    value={form.collectionDate}
                                    onChange={this.handleDateChange('collectionDate')}
                                    dateFormat="DD-MM-YYYY"
                                    timeFormat="HH:mm"
                                    inputProps={{ maxLength: 255 }}
                                    className={errors.collectionDate && 'datetime-error'}
                                />
                                {errors.collectionDate && (
                                    <HelpBlock>
                                        <span className="text-danger">{errors.collectionDate}</span>
                                    </HelpBlock>
                                )}
                            </Col>
                            <Col sm={2} style={{ marginTop: 10 }}>
                                Carrier *
                            </Col>
                            <Col sm={4} style={{ marginTop: 5 }}>
                                <FormControl
                                    name="carrier"
                                    value={form.carrier}
                                    onChange={this.handleChange}
                                    componentClass="select"
                                >
                                    <option value="">Select carrier</option>
                                    {logisticPartners &&
                                        logisticPartners.map(lp => (
                                            <option key={lp} value={lp}>
                                                {lp}
                                            </option>
                                        ))}
                                </FormControl>
                                {errors.carrier && (
                                    <HelpBlock>
                                        <span className="text-danger">{errors.carrier}</span>
                                    </HelpBlock>
                                )}
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={2} style={{ marginTop: 10 }}>
                                Arrival date *
                            </Col>
                            <Col sm={4} style={{ marginTop: 5 }}>
                                <Datetime
                                    value={form.arrivalDate}
                                    onChange={this.handleDateChange('arrivalDate')}
                                    dateFormat="DD-MM-YYYY"
                                    timeFormat="HH:mm"
                                    inputProps={{ maxLength: 255 }}
                                    className={errors.arrivalDate && 'datetime-error'}
                                />
                                {errors.arrivalDate && (
                                    <HelpBlock>
                                        <span className="text-danger">{errors.arrivalDate}</span>
                                    </HelpBlock>
                                )}
                            </Col>
                            <Col sm={2} style={{ marginTop: 10 }}>
                                Trailer number
                            </Col>
                            <Col sm={4} style={{ marginTop: 5 }}>
                                <FormControl
                                    name="trailerIdentifier"
                                    value={form.trailerIdentifier}
                                    onChange={this.handleChange}
                                    type="text"
                                    maxLength="1000"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={2} style={{ marginTop: 10 }}>
                                Unloading date
                            </Col>
                            <Col sm={4} style={{ marginTop: 5 }}>
                                <Datetime
                                    value={form.unloadingDate}
                                    onChange={this.handleDateChange('unloadingDate')}
                                    dateFormat="DD-MM-YYYY"
                                    timeFormat="HH:mm"
                                    inputProps={{ maxLength: 255 }}
                                    className={errors.unloadingDate && 'datetime-error'}
                                />
                                {errors.unloadingDate && (
                                    <HelpBlock>
                                        <span className="text-danger">{errors.unloadingDate}</span>
                                    </HelpBlock>
                                )}
                            </Col>
                        </Row>
                        <Row style={{ marginTop: 20 }}>
                            <Col sm={2} style={{ marginTop: 10 }}>
                                Due date *
                            </Col>
                            <Col sm={4} style={{ marginTop: 5 }}>
                                <Datetime
                                    value={form.dueDate}
                                    onChange={this.handleDateChange('dueDate')}
                                    dateFormat="DD-MM-YYYY"
                                    timeFormat="HH:mm"
                                    inputProps={{ maxLength: 255 }}
                                    className={errors.dueDate && 'datetime-error'}
                                />
                                {errors.dueDate && (
                                    <HelpBlock>
                                        <span className="text-danger">{errors.dueDate}</span>
                                    </HelpBlock>
                                )}
                            </Col>
                        </Row>
                        <Row>
                            <div style={{ margin: 15 }}>
                                <Comments
                                    style={{ margin: 15 }}
                                    comment={form.comment}
                                    onCommentChange={this.handleChange}
                                />
                            </div>
                        </Row>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="success"
                        onClick={this.handleConfirm}
                    >
                        Create
                    </Button>
                    <Button
                        className="pull-right"
                        style={{ marginRight: 20 }}
                        bsStyle="default"
                        onClick={this.handleClose}
                    >
                        Dismiss
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default SpecialModalGeneric;
